export class PassengerManualNotif {
  id: number;
  busId: number;
  schoolName: string;
  date: string;
  subject: string;
  message: string;
  isSent: boolean;
  type: string;
  // bus

  constructor() {
    this.isSent = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/passenger-manual-notif.ts